import { httpInterceptor } from '../http-interceptor';

export class MoldService {
  static ENDPOINTS = {
    GET_ALL: 'Mold/getAllToolDetailsByMoldInfoID',
    GET_ALL_WITH_OPEN_FILTER: 'Mold/getAllToolDetailsByMoldInfoIDWithOpenFilter',
    GET_BY_ID: 'Mold/getMoldDetailsByMoldInfoID',
    GET_BY_TOOLID: 'Mold/getMoldDetailsByToolID',
    GET_ALL_WITH_FILTER: 'Mold/getToolDetailsByReceivedDate',
    GET_MAINTENANCE_BY_TOOLID: 'Mold/getMoldMaintenanceByToolID',
    GET_MAINTENANCE_RECORDS_DETAILS: 'Mold/getMoldMaintenanceByToolID',
    GET_RELEASE_BY_TOOLID: 'Mold/getMoldReleaseByToolID',
    GET_RELEASE_BY_CATEGORY: 'Mold/getMoldReleaseByCategory',
    GET_ALL_MAINTENANCE_BY_TOOLID: 'Mold/getAllMoldMaintenanceByToolID',
    GET_ALL_MAINTENANCE: 'Mold/getAllMoldMaintenance',
    SAVE_UPDATE_RECEIVING: 'Mold/saveOrUpdateMoldReceiving',
    SAVE_UPDATE_MAINTENANCE: 'Mold/saveOrUpdateMoldMaintenance',
    SAVE_UPDATE_MAINTENANCE_ACTIVITY: 'Mold/saveOrUpdateMoldMaintenanceActivity',
    GET_MAINTENANCE_ACTIVITY_BY_ID: 'Mold/getMoldMaintenanceActivityByIdAsync',
    SAVE_UPDATE_MAINTENANCE_ACTIVITY_ISSUE: 'Mold/saveOrUpdateMoldMaintenanceActivityIssue',
    GET_MAINTENANCE_ACTIVITY_ISSUE: 'Mold/getMoldMaintenanceActivityIssue',
    DELETE_MAINTENANCE_IMAGE_SEGMENT: 'Mold/deleteMoldMaintenanceImageSegment',
    SAVE_UPDATE_RELEASE: 'Mold/saveOrUpdateMoldRelease',
    SAVE_UPDATE_RELEASE_DRAFT: 'Mold/saveOrUpdateMoldReleaseDraft',
    UPLOAD_MOLD_DOCUMENT: 'Customer/Upload',
    SAVE_UPDATE_IMAGE_SEGMENTS: 'Mold/saveOrUpdateMoldImageSegments',
    GET_MOLD_MAINTENANCE_SEGMENTS: 'Mold/getMoldMaintenanceSegments',
    GET_MOLD_RECEIVING_SEGMENTS: 'Mold/getMoldReceivingSegments',
    UPDATE_IMAGE_SEGMENT_TITLE: 'Mold/updateMoldMaintenanceImageSegmentTitle',
    UPDATE_IMAGE_SEGMENT_DESCRIPTION: 'Mold/updateMoldMaintenanceImageSegmentDescription',
    GET_IMAGE_SEGMENT_TITLE_BY_ID: 'Mold/getMoldMaintenanceImageSegmentTitleById',
    GET_IMAGE_SEGMENT_DESCRIPTION_BY_ID: 'Mold/getMoldMaintenanceImageSegmentDescriptionById',
    GET_ALL_CATEGORIES: 'Mold/getAllCategories',
    UPDATE_MOLD_MAINTENANCE_IMAGE_SEGMENT: 'Mold/updateMoldMaintenanceImageSegment',
    GET_MOLD_MAINTENANCE_FUTURE_ACTIONS: 'Mold/GetMoldMaintenanceFutureActions',
    GET_MOLD_MAINTENANCE_FUTURE_ACTIONS_BY_MAINTENANCE_ID: 'Mold/GetMoldMaintenanceFutureActionsByMaintenanceId',
    SAVE_MOLD_MAINTENANCE_FUTURE_ACTION: 'Mold/saveMoldMaintenanceFutureAction',
    GET_ALL_FUTURE_ACTIONS: 'Mold/getAllFutureActions',
    TOOL_TAG_PRINT: 'Mold/ToolTagPrint',
  };

  static async getAllMold(data) {
    if (data?.fromDate && data?.toDate) {
      return httpInterceptor.get(
        `${this.ENDPOINTS.GET_ALL_WITH_FILTER}/${data.fromDate}/${data.toDate}`,
      );
    }
    return httpInterceptor.get(`${this.ENDPOINTS.GET_ALL}/1`);
  }
  static async getAllMoldByStatus(isReleased) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_ALL}/${isReleased}`);
  }

  static async getAllToolDetailsByMoldInfoID(moldInfoId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_ALL}/${moldInfoId}`);
  }

  /**
   * Mold Maintenance only.
   * @param {number} isReleased - 1 = not released, 0 = released
   * @param {number} recordFilter - 0 = All Molds, 1 = Open Records, 2 = Molds With Records (latest CLOSED)
   */
  static async getAllToolDetailsByMoldInfoIDWithOpenFilter(isReleased = 1, recordFilter = 1) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_ALL_WITH_OPEN_FILTER}/${isReleased}/${recordFilter}`,
    );
  }

  static async getMoldById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${id}`);
  }
  static async getMoldByToolId(toolId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_TOOLID}/${toolId}`);
  }

  static async getMoldByToolIdWithCategory(toolId, category) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_TOOLID}/${toolId}/${category}`);
  }
  static async getMoldMaintenanceByToolId(toolId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_BY_TOOLID}/${toolId}`);
  }
  static async getMoldReleaseByToolId(toolId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_RELEASE_BY_TOOLID}/${toolId}`);
  }

  static async getMoldReleaseByCategory(toolId, category) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_RELEASE_BY_CATEGORY}/${toolId}/${category}`);
  }
  static async getMaintenanceRecordsDetails(toolId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORDS_DETAILS}/${toolId}`);
  }
  static async getAllMoldMaintenanceByToolId(toolId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_ALL_MAINTENANCE}/${toolId}`);
  }
  static async getAllMoldMaintenanceByToolIdAndId(toolId, id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_ALL_MAINTENANCE_BY_TOOLID}/${toolId}/${id}`);
  }
  static async saveUpdateReceiving(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_UPDATE_RECEIVING, data);
  }

  static async saveUpdateMaintenance(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_UPDATE_MAINTENANCE, data);
  }

  static async saveUpdateMaintenanceActivity(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_UPDATE_MAINTENANCE_ACTIVITY, data);
  }

  static async getMoldMaintenanceActivityById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_ACTIVITY_BY_ID}/${id}`);
  }

  static async saveOrUpdateMoldMaintenanceActivityIssue(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_UPDATE_MAINTENANCE_ACTIVITY_ISSUE, data);
  }

  static async getMoldMaintenanceActivityIssue(activityIssueId, maintenanceId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_ACTIVITY_ISSUE}/${activityIssueId}/${maintenanceId}`);
  }

  static async deleteMoldMaintenanceImageSegment(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_MAINTENANCE_IMAGE_SEGMENT}/${id}`);
  }

  static async saveUpdateRelease(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_UPDATE_RELEASE, data);
  }

  static async saveOrUpdateMoldReleaseDraft(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_UPDATE_RELEASE_DRAFT, data);
  }

  static async uploadMoldDocument(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_MOLD_DOCUMENT, data);
  }
  static async saveUpdateImageSegments(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_UPDATE_IMAGE_SEGMENTS, data);
  }

  static async getMoldMaintenanceSegments(moldInfoID, record, maintenanceId = 0, actionImageId = null, subActionImageId = null) {
    let url = `${this.ENDPOINTS.GET_MOLD_MAINTENANCE_SEGMENTS}/${moldInfoID}/${record}/${maintenanceId}`;

    console.log('MoldService.getMoldMaintenanceSegments called with:', {
      moldInfoID,
      record,
      maintenanceId,
      actionImageId,
      subActionImageId
    });

    // Always add actionImageId and subActionImageId when maintenanceId is provided
    if (maintenanceId > 0) {
      url += `/${actionImageId || 0}/${subActionImageId || 0}`;
    }

    console.log('MoldService.getMoldMaintenanceSegments final URL:', url);

    return httpInterceptor.get(url);
  }

  static async getMoldReceivingSegments(moldInfoID, record, category = 'Mold-Receiving') {
    const url = `${this.ENDPOINTS.GET_MOLD_RECEIVING_SEGMENTS}/${moldInfoID}/${record}/${category}`;

    return httpInterceptor.get(url);
  }

  static async updateImageMetadata(imageId, title, description) {
    return httpInterceptor.put(`${this.ENDPOINTS.SAVE_UPDATE_IMAGE_SEGMENTS}/${imageId}`, {
      title,
      description
    });
  }

  static async deleteImageSegmentsByMaintenanceId(moldInfoID, record, maintenanceId = 0) {
    return httpInterceptor.delete(`${this.ENDPOINTS.SAVE_UPDATE_IMAGE_SEGMENTS}/${moldInfoID}/${record}/${maintenanceId}`);
  }

  static async updateImageSegmentsMaintenanceId(moldInfoID, record, newMaintenanceId) {
    return httpInterceptor.put(`${this.ENDPOINTS.SAVE_UPDATE_IMAGE_SEGMENTS}/updateMaintenanceId`, {
      moldInfoID,
      record,
      newMaintenanceId
    });
  }

  static async updateImageSegmentTitle(id, title) {
    return httpInterceptor.post(this.ENDPOINTS.UPDATE_IMAGE_SEGMENT_TITLE, {
      Id: id,
      Title: title
    });
  }

  static async updateImageSegmentDescription(id, description) {
    return httpInterceptor.post(this.ENDPOINTS.UPDATE_IMAGE_SEGMENT_DESCRIPTION, {
      Id: id,
      Description: description
    });
  }

  static async getImageSegmentTitleById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_IMAGE_SEGMENT_TITLE_BY_ID}/${id}`);
  }

  static async getImageSegmentDescriptionById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_IMAGE_SEGMENT_DESCRIPTION_BY_ID}/${id}`);
  }

  static async getAllCategories() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL_CATEGORIES);
  }

  static async updateMoldMaintenanceImageSegment(data, oldSegment) {
    // Extract only the required fields and exclude Segment
    const { Segment, ...otherData } = data;
    const payload = {
      ...otherData,
      OldSegment: oldSegment,
      NewSegment: Segment
    };
    console.log('API payload being sent:', payload);
    return httpInterceptor.post(this.ENDPOINTS.UPDATE_MOLD_MAINTENANCE_IMAGE_SEGMENT, payload);
  }

  static async getMoldMaintenanceFutureActions(moldInfoId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MOLD_MAINTENANCE_FUTURE_ACTIONS}/${moldInfoId}`);
  }

  static async getMoldMaintenanceFutureActionsByMaintenanceId(moldInfoId, maintenanceId, activityIssueId = 0) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MOLD_MAINTENANCE_FUTURE_ACTIONS_BY_MAINTENANCE_ID}/${moldInfoId}/${maintenanceId}/${activityIssueId}`);
  }

  static async saveMoldMaintenanceFutureAction(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MOLD_MAINTENANCE_FUTURE_ACTION, data);
  }

  static async getAllFutureActions(isReleased) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_ALL_FUTURE_ACTIONS}/${isReleased}`);
  }

  static async printToolTag(toolId, printerId) {
    return httpInterceptor.post(this.ENDPOINTS.TOOL_TAG_PRINT, {
      ToolId: toolId,
      PrinterId: printerId
    });
  }
}
